export default "__VITE_ASSET__DY4Jr06f__"